import { useCallback } from "react"
import { useQuery } from "urql"

import type { Company, GetSiblingCompanyPreferenceQuery } from "@/graphql/codegen/graphql"
import { GetSiblingCompanyPreferenceDocument } from "@/graphql/codegen/graphql"

interface UseGetCompanySiblingsResult {
  siblingCompanies: Company[] | null
  isFetching: boolean
  hasError: boolean
  refetch: () => void
}

export const useGetCompanySiblings = ({ companyId }: { companyId: string }): UseGetCompanySiblingsResult => {
  const [result, refetch] = useQuery<GetSiblingCompanyPreferenceQuery>({
    query: GetSiblingCompanyPreferenceDocument,
    variables: {
      input: {
        companyId,
      },
    },
  })

  const refetchSiblings = useCallback(() => {
    refetch({ requestPolicy: "network-only" })
  }, [refetch])

  const data =
    result.data?.companySibling.list.__typename === "CompanySiblingListSuccess"
      ? (result.data.companySibling.list.siblingCompanies as Company[])
      : null

  const hasError = !!result.error || result.data?.companySibling.list.__typename === "CompanySiblingListFailure"

  return {
    siblingCompanies: data ?? null,
    isFetching: result.fetching,
    hasError,
    refetch: refetchSiblings,
  }
}
